export default "__VITE_ASSET__CB9Tcf3O__"